module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span data-orderby="auto" '+
((__t=( active == "auto" ? 'class="active"' : '' ))==null?'':__t)+
'>\n	'+
((__t=( __("sort_auto") ))==null?'':__t)+
'\n</span>\n<span data-orderby="booking" '+
((__t=( active == "booking" ? 'class="active"' : '' ))==null?'':__t)+
'>\n	'+
((__t=( __("sort_booking") ))==null?'':__t)+
'\n</span>\n<span data-orderby="stars" '+
((__t=( active == "stars" ? 'class="active"' : '' ))==null?'':__t)+
'>\n	'+
((__t=( __("sort_stars") ))==null?'':__t)+
'\n</span>\n<span data-orderby="ratings" '+
((__t=( active == "ratings" ? 'class="active"' : '' ))==null?'':__t)+
'>\n	'+
((__t=( __("sort_ratings") ))==null?'':__t)+
'\n</span>\n<span data-orderby="price" '+
((__t=( active == "price" ? 'class="active"' : '' ))==null?'':__t)+
'>\n	'+
((__t=( __("sort_price") ))==null?'':__t)+
'\n</span>\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/engine/SortOrderTemplate.html
// module id = 58
// module chunks = 0